var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isWeb2UserConnected)?_c('home-dashboard'):_c('landing')
}
var staticRenderFns = []

export { render, staticRenderFns }